import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronDownIcon, ArrowLeftIcon } from 'lucide-react';
import { useTheme } from '../providers/ThemeProvider';
export const KnowledgeBaseSchedulingLessons = () => {
  const {
    theme
  } = useTheme();
  const darkMode = theme === 'dark';
  const navigate = useNavigate();
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    question: 'How do I schedule a lesson?',
    answer: 'Lessons can be scheduled by teachers from the Teacher Dashboard or directly from the Calendar.'
  }, {
    question: 'Where can I create lessons from?',
    answer: 'Teachers can create lessons by clicking Create Lesson from the dashboard or by selecting a date and time directly on the calendar.'
  }, {
    question: 'What information is set when scheduling a lesson?',
    answer: 'When scheduling a lesson, teachers choose a student, date, time, duration, and lesson location. Notes can also be added if needed.'
  }, {
    question: 'Where do scheduled lessons appear?',
    answer: "Once created, lessons appear in the teacher's and student's calendar and dashboard."
  }];
  return <main className="pb-6" data-id="element-5631">
      <div className="max-w-4xl mx-auto px-4" data-id="element-5632">
        {/* Back button */}
        <button onClick={() => navigate('/help-support')} className={`flex items-center mb-6 ${darkMode ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-900'} transition-colors`} data-id="element-5633">
          <ArrowLeftIcon className="h-4 w-4 mr-2" data-id="element-5634" />
          Back to Help & Support
        </button>

        {/* Header */}
        <div className="mb-8" data-id="element-5635">
          <h1 className="text-2xl sm:text-3xl font-bold mb-2" data-id="element-5636">
            Scheduling Lessons
          </h1>
          <p className={`text-lg ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-5637">
            Learn how to schedule and manage lessons
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="space-y-3" data-id="element-5638">
          {faqs.map((faq, index) => <div key={index} className={`rounded-lg overflow-hidden ${darkMode ? 'bg-navy-800' : 'bg-white'} shadow-sm`} data-id="element-5639">
              <button className={`w-full px-6 py-4 text-left flex justify-between items-center hover:${darkMode ? 'bg-navy-700' : 'bg-gray-50'} transition-colors`} onClick={() => toggleFaq(index)} data-id="element-5640">
                <span className={`font-medium text-lg ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-5641">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`h-5 w-5 ${darkMode ? 'text-gray-400' : 'text-gray-500'} transition-transform flex-shrink-0 ml-4 ${openFaq === index ? 'transform rotate-180' : ''}`} data-id="element-5642" />
              </button>
              {openFaq === index && <div className={`px-6 py-4 ${darkMode ? 'border-t border-navy-700' : 'border-t border-gray-200'}`} data-id="element-5643">
                  <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'} leading-relaxed`} data-id="element-5644">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </main>;
};